import React from 'react';
import { Text, Box } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
export const ArchiveIndicator: React.FC<{ inverse?: boolean }> = ({ inverse = false }) => (
  <Box data-component="ArchiveIndicator" marginLeft={4} flexShrink={0}>
    <Text appearance="bodyMedium" color={inverse ? 'default-inverse' : 'secondary'}>
      <FormattedMessage
        defaultMessage="(Archived)"
        id="Rpe8JT"
        description="Indicator for an object that has been archived"
      />
    </Text>
  </Box>
);
